import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { reduxForm } from 'redux-form';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'moment/locale/pt-br'
import 'react-datepicker/dist/react-datepicker.css';
import Moment from 'react-moment';
import ptBR from 'date-fns/locale/pt-BR';
import moment from 'moment';
import { ativarItinerarioEmLote, inativarItinerarioEmLote, limpaResultadoAtivacaoItinerarioEmLote } from '../../actions/itinerario/ativarOuInativarItinerarioEmLote';
import {showSuccessMsg} from '../../util/messagesUtil';
import Titulo from '../comum/Titulo';
import {    
    getAdminEmpresa,
    getGestorEmpresa,
    getGestorOperacoes,
    getOperadorEmpresa,    
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';

const DIAS_SEMANA = [
    {label: 'Dom', value: 'SUNDAY'},
    {label: 'Seg', value: 'MONDAY'},
    {label: 'Ter', value: 'TUESDAY'},
    {label: 'Qua', value: 'WEDNESDAY'},
    {label: 'Qui', value: 'THURSDAY'},
    {label: 'Sex', value: 'FRIDAY'},
    {label: 'Sab', value: 'SATURDAY'},
];

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

export class PainelAtivcaoItinerarioEmLote extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);   
        this.handleChecked = this.handleChecked.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);

        this.state = {
            retorno: '/painel-itinerarios',
            dataInicio: null, dataFim: null, diasSelecionados: [], ativo: true
        }                       
    }

    UNSAFE_componentDidMount() {
        this.props.limpaResultadoAtivacaoItinerarioEmLote();        
        this.limparFormulario();
    }

    exibirDiasSemana() {
        return DIAS_SEMANA.map(it => <p key={it.value}
                                        className={this.state.diasSelecionados.includes(it.value) ? 'dot selected ml-1' : 'dot ml-1'}
                                        onClick={() => this.selecionarDia(it.value)}>{it.label}</p>)
    }

    selecionarDia(dia) {
        const lista = this.state.diasSelecionados;
        if (lista.includes(dia)) {
            this.setState({diasSelecionados: lista.filter(it => it !== dia)})
        } else {
            lista.push(dia);
            this.setState({diasSelecionados: lista})
        }
    }

    handleChecked() {
        this.setState({ ativo: !this.state.ativo });        
    }

    montarParametroItinerario() {        
        return {
            dataInicio: moment(this.state.dataInicio).format('DD/MM/YYYY'),
            dataFim: moment(this.state.dataFim).format('DD/MM/YYYY'),
            diasSemana: this.state.diasSelecionados,            
            empresaId: this.props.empresaSelecionada.id,
            rotaId: this.props.rotaSelecionada.value,
            ativo: this.state.ativo
        }
    }

    submit() {      
        const parametros = this.montarParametroItinerario();  
        if (this.state.ativo) {
            this.props.ativarItinerarioEmLote(parametros)
                .then(() => {
                    if (this.props.resultadoAtivacaoItinerarioEmLote && this.props.resultadoAtivacaoItinerarioEmLote.length > 0) {
                        showSuccessMsg('Os itinerários foram ativados com sucesso');
                        this.limparFormulario();
                    }
                });            
        } else {
            this.props.inativarItinerarioEmLote(parametros)
                .then(() => {
                    if (this.props.resultadoAtivacaoItinerarioEmLote && this.props.resultadoAtivacaoItinerarioEmLote.length > 0) {
                        showSuccessMsg('Os itinerários foram desativados com sucesso');                                        
                        this.limparFormulario();
                    }
                });
        }
    }
   

    limparFormulario() {
        this.props.reset('formularioAtivarInativarItinerarioEmLote');
        this.setState({dataInicio: null, dataFim: null, diasSelecionados: [], ativo: false});        
    }

    selecionarData(data, inicio) {
        if (inicio) {
            this.setState({dataInicio: data, dataFim: null})
        } else {
            this.setState({data, dataFim: data})
        }
    }

    exibirCalendario(inicio) {
        let data;

        let minDate = new Date();
        if (inicio) {
            if (this.state.dataInicio) {
                data = moment(this.state.dataInicio)
                    .toDate()
            }
        } else {
            minDate = moment(this.state.dataInicio)
                .add(1, 'days')
                .toDate();
            if (this.state.dataFim) {
                data = moment(this.state.dataFim)
                    .toDate()
            }
        }
        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        value={data}
                        locale="pt-BR"
                        minDate={minDate}
                        selected={data}
                        startDate={moment(this.state.dataInicio)
                            .toDate()}
                        endDate={moment(this.state.dataFim)
                            .toDate()}
                        disabled={!inicio && !this.state.dataInicio}
                        onChange={date => this.selecionarData(date, inicio)}
                        dateFormat="dd/MM/yyyy"
                        withPortal
                    />
                </div>
            </div>
        )
    }

    exibieResultadoProcessamento() {
        return (
            <div className="lista-table">
                <table className="table table-striped table-bordered" data-show-print={true}>
                    <thead>
                    <tr>
                        <td colSpan={7} className='text-center'><strong>Resultado do processamento</strong>
                        </td>
                    </tr>
                    <tr>
                        <th>Data/Hora saída</th>
                        <th>Assentos</th>
                        <th>Veículo</th>
                        <th>Rota</th>
                        <th>Prestador</th>                                                  
                        <th>Itinerário<br/>ativo/inativo</th>
                        <th>Situação</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.props.resultadoAtivacaoItinerarioEmLote && this.props.resultadoAtivacaoItinerarioEmLote.map((retorno, index) => <tr key={'retorno' + index}>
                        <td><Moment
                                format="DD/MM/YYYY">{retorno.dataPartida}</Moment>  - {retorno.horaSaida}</td>
                        <td>{retorno.assentosDisponiveis}</td>                                         
                        <td>{retorno.descricaoVeiculo}</td>
                        <td>{retorno.descricaoRota}</td>
                        <td>{retorno.prestador ? retorno.prestador.valor : 'Frota própria'}</td>
                        <td>{retorno.ativo ? 'Ativo' : 'Inativo'}</td>                                        
                        <td>{retorno.temPoltronaTemporariaVigente ? 'bloqueio temporário vigente' : 'sem bloqueio'}</td>
                    </tr>)}
                    {this.props.resultadoAtivacaoItinerarioEmLote && this.props.resultadoAtivacaoItinerarioEmLote.length == 0 && <tr>
                        <td colSpan={7}>Nenhuma informação processada.</td>   
                     </tr>}
                    </tbody>
                </table>
                <button className='btn btn-laranja'
                        onClick={() => {
                            this.limparFormulario();
                            this.props.limpaResultadoAtivacaoItinerarioEmLote();     
                            this.props.history.push(this.state.retorno);                       
                        }}>Voltar
                </button>
        </div>
        )
    }

    formulario() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;
        return (            
            <>
                <form onSubmit={handleSubmit(this.submit)}>
                    <fieldset className="scheduler-border">
                        <legend className="scheduler-border">Informações básicas</legend>
                        <div className="col-12 col-sm-4 col-md-4 mt-2">
                            <label>Opera em quais dias da semana?</label>
                            <div className='form-row'>
                                {this.exibirDiasSemana()}
                            </div>
                        </div>
                        <div className="col-12 col-sm-4 col-md-2 mt-2">
                            <label>Quando começa?</label>
                            {this.exibirCalendario(true)}
                        </div>
                        <div className="col-12 col-sm-4 col-md-2 mt-2">
                            <label>Quando encerra?</label>
                            {this.exibirCalendario()}
                        </div>                                                
                        <div className="col-12 col-sm-2 col-md-2 mt-3" style={{display: 'flex', alignItems: 'center'}}>
                            <span className='mt-2'></span>                                               
                            <div className='form-group form-check'>                                                                 
                                <input type="radio" name='ativo'
                                        className='form-check-input' onChange={this.handleChecked} value={this.state.ativo} checked={this.state.ativo} />                                
                                    <label className='form-check-label'>Ativo</label>
                            </div>
                            <div className='form-group form-check ml-2'>                                                                 
                                <input type="radio" name='ativo'
                                        className='form-check-input' onChange={this.handleChecked} value={!this.state.ativo} checked={!this.state.ativo} />                                
                                    <label className='form-check-label'>Inativo</label>
                            </div>
                        </div>                        
                    </fieldset>                                        
                    <div className="modal-footer">
                        <button type="submit" 
                                disabled={invalid || submitting || !this.state.dataInicio
                                    || !this.state.dataFim || !this.state.diasSelecionados.length}
                                className="btn btn-laranja">Salvar</button>
                        <button className='btn btn-laranja' 
                                onClick={() =>{ 
                                    this.limparFormulario();
                                    this.props.limpaResultadoAtivacaoItinerarioEmLote();
                                    this.props.history.push(this.state.retorno)}}>
                                Voltar
                        </button>
                    </div>
                </form>                
            </>
        );
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="row">
                    <Titulo texto="Alterar Ativo/Inativo Itinerário" urlRetorno={this.state.retorno}/>                    
                    <div className='col-12'>
                        {this.props.resultadoAtivacaoItinerarioEmLote ? this.exibieResultadoProcessamento() : this.formulario()}
                    </div>

                </div>
            </Autorizacao>
        )
    }
}

export const mapStateToProps = state => {
    return {
        empresaSelecionada: state.empresaSelecionada,        
        rotaSelecionada: state.rotaSelecionada,
        resultadoAtivacaoItinerarioEmLote: state.ativacaoItinerarioEmLote.resultadoAtivacaoItinerarioEmLote,
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({                
        ativarItinerarioEmLote,
        inativarItinerarioEmLote,
        limpaResultadoAtivacaoItinerarioEmLote       
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioAtivarInativarItinerarioEmLote',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(PainelAtivcaoItinerarioEmLote));